import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import s from './wordAnalysis.module.css';
import {getData, postData} from '../middleware/apiMiddleware';
import {modifiedDate} from '../middleware/dateControl';
import {getGeneralStorage, setGeneralStorage} from '../middleware/dataStorage';
import { useOutletContext } from "react-router-dom";

import uploadPng from'../asset/upload.png';
import dicePng from'../asset/dice.png';

const FormatMeaningQtn = ({format, data, setData, inputValue, setInputValue, createWordQtn}) => {
	
	const navigate = useNavigate();
	const rerollMeaningQtn = async (w, indexD) => {
		data[indexD].rerollingMeaningQtn = true;
		setData([...data])
		
		let obj = { qId: w.qId, wId: w.wordId, word: w.word }
		
		let res;
		if (format == 'qmeaning') {
			res = await postData("wordApi/rerollMeaningQtn", obj, navigate)
		} else {
			res = await postData("wordApi/rerollMeaningQtnHk", obj, navigate)
		}
		
		
		let answer = res.data.answer;
		let option1 = res.data.option1;
		let option2 = res.data.option2;
		let option3 = res.data.option3;
		
		data[indexD].answer = answer;
		data[indexD].option1 = option1;
		data[indexD].option2 = option2;
		data[indexD].option3 = option3;
		data[indexD].rerollingMeaningQtn = false;
		setData([...data])
		
		inputValue[w.wordId.toString()] = w;
		inputValue[w.wordId.toString()].answer = answer;
		inputValue[w.wordId.toString()].option1 = option1;
		inputValue[w.wordId.toString()].option2 = option2;
		inputValue[w.wordId.toString()].option3 = option3;
		
		setInputValue({...inputValue});
	}
	
	
	return (<div style={{margin:"10px 0", fontSize:"0.8rem"}}>
			<div style={{display:"flex", flexWrap:"nowrap", margin:"0 30px", borderBottom:"1px solid #4b3f1b", color:"#75390b", alignItems:"flex-end"}}>
				<div className={s.tableHeader} style={{flex: '0 0 30px', letterSpacing:"-0.1rem"}}>Reroll</div>
				<div className={s.tableHeader} style={{flex: '0 0 40px', letterSpacing:"0.1rem"}}>Id</div>
				<div className={s.tableHeader} style={{flex: '0 0 90px'}}>WORD</div>
				<div className={s.tableHeader} style={{flex: '0 0 300px'}}><span className={s.tableHeaderSpan}>ANSWER</span></div>
				<div className={s.tableHeader} style={{flex: '0 0 340px'}}>OPTION 1</div>
				<div className={s.tableHeader} style={{flex: '0 0 360px'}}>OPTION 2</div>
				<div className={s.tableHeader} style={{flex: '0 0 330px'}}>OPTION 3</div>
			</div>
		{
			data.map((d, indexD) => (<div key={'meaning-' + indexD}
				style={{display:"flex", flexWrap:"nowrap", margin:"0 30px"
				, alignItems:"center"
				, backgroundColor:(indexD%2==0) ? "white" : "#22222222"
				}}
				>
				
				{
					(!d.qcType) &&
					(<>
						<div className={s.wordTitleCreate} onClick={()=>createWordQtn(d.wordId, d.word)}>
							{d.word} 
							<span>click to create</span>
						</div>
					</>)
				}
				{
					(d.qcType) &&
					(<>
						
						<div className={s.diceIconHolder} onClick={()=>rerollMeaningQtn(d, indexD)}>
							<img className={s.diceIcon} src={dicePng} />
							{
								(d.rerollingMeaningQtn) && (<img className={s.diceIconRerolling} src={dicePng} />)
							}
						</div>
						<div className={s.wordId} >{d.wordId}</div>
					
						<div className={s.wordTitle} >{d.word}</div>
						<div className={s.growWrap} dataReplicatedValue={d.answer}>
						<textarea rows="1" value={d.answer} onChange={(e)=>{
							data[indexD].answer = e.target.value;
							setData([...data])
							
							inputValue[d.wordId.toString()] = d;
							inputValue[d.wordId.toString()].answer = e.target.value;
							setInputValue({...inputValue});
						}} />
					</div>
					<div className={s.growWrap} dataReplicatedValue={d.option1}>
						<textarea rows="1" value={d.option1} onChange={(e)=>{
							data[indexD].option1 = e.target.value;
							setData([...data])
							
							inputValue[d.wordId.toString()] = d;
							inputValue[d.wordId.toString()].option1 = e.target.value;
							setInputValue({...inputValue});
						}} />
					</div>
					<div className={s.growWrap} dataReplicatedValue={d.option2}>
						<textarea rows="1" value={d.option2} onChange={(e)=>{
							data[indexD].option2 = e.target.value;
							setData([...data])
							
							inputValue[d.wordId.toString()] = d;
							inputValue[d.wordId.toString()].option2 = e.target.value;
							setInputValue({...inputValue});
						}} />
					</div>
					<div className={s.growWrap} dataReplicatedValue={d.option3}>
						<textarea rows="1" value={d.option3} onChange={(e)=>{
							data[indexD].option3 = e.target.value;
							setData([...data])
							
							inputValue[d.wordId.toString()] = d;
							inputValue[d.wordId.toString()].option3 = e.target.value;
							setInputValue({...inputValue});
						}} />
					</div>
					<div className={s.wordMsgDate} >{modifiedDate(d.updateTs)} @ {d.username}</div></>)
				}
				
			</div>))
		}
	
	</div>);
}

const FormatBasic = ({data, setData, inputValue, setInputValue}) => {
	
	const navigate = useNavigate();
	const rerollMeaning = async (w, wordId, word, indexD) => {
		data[indexD].rerollingMeaning = true;
		setData([...data])
		
		let obj = { wordId, word }
		
		let res = await postData("wordApi/rerollMeaning", obj, navigate)
		let en = res.data.en;
		let hk = res.data.hk;
		
		
		data[indexD].sMeaning = en;
		data[indexD].sMeaningHk = hk;
		data[indexD].rerollingMeaning = false;
		setData([...data])
		
		inputValue[w.wordId.toString()] = w;
		inputValue[w.wordId.toString()].sMeaning = en;
		inputValue[w.wordId.toString()].sMeaningHk = hk;
		setInputValue({...inputValue});
	}
	
	
	return (<div style={{margin:"10px 0", fontSize:"0.8rem"}}>
			<div style={{display:"flex", flexWrap:"nowrap", margin:"0 30px", borderBottom:"1px solid #4b3f1b", color:"#75390b", alignItems:"flex-end"}}>
				<div className={s.tableHeader} style={{flex: '0 0 30px', letterSpacing:"-0.1rem"}}>Reroll</div>
				<div className={s.tableHeader} style={{flex: '0 0 40px', letterSpacing:"0.1rem"}}>Id</div>
				<div className={s.tableHeader} style={{flex: '0 0 90px'}}>WORD</div>
				<div className={s.tableHeader} style={{flex: '0 0 265px'}}>MEANING HK</div>
				<div className={s.tableHeader} style={{flex: '0 0 310px'}}>MEANING</div>
				<div className={s.tableHeader} style={{flex: '0 0 1645px'}}>IPA</div>
			</div>
		{
			data.map((d, indexD) => (<div key={'basic-' + indexD}
				style={{display:"flex", flexWrap:"nowrap", margin:"0 30px", alignItems:"center"
				, backgroundColor:(indexD%2==0) ? "white" : "#22222222"
				}}
				>
				<div className={s.diceIconHolder} onClick={()=>rerollMeaning(d, d.wordId, d.word, indexD)}>
					<img className={s.diceIcon} src={dicePng} />
					{
						(d.rerollingMeaning) && (<img className={s.diceIconRerolling} src={dicePng} />)
					}
				</div>
				<div className={s.wordId} >{d.wordId}</div>
				<div className={s.wordTitle} >{d.word}</div>
				<div className={s.growWrap} style={{maxWidth:"300px",width:"300px",minWidth:"300px"}} dataReplicatedValue={d.sMeaningHk}>
					<textarea rows="1" value={d.sMeaningHk} onChange={(e)=>{
						data[indexD].sMeaningHk = e.target.value;
						setData([...data])
						
						inputValue[d.wordId.toString()] = d;
						inputValue[d.wordId.toString()].sMeaningHk = e.target.value;
						setInputValue({...inputValue});
					}} />
				</div>
				<div className={s.growWrap} style={{maxWidth:"1000px",width:"1000px",minWidth:"1000px"}} dataReplicatedValue={d.sMeaning}>
					<textarea rows="1" value={d.sMeaning} onChange={(e)=>{
						data[indexD].sMeaning = e.target.value;
						setData([...data])
						
						inputValue[d.wordId.toString()] = d;
						inputValue[d.wordId.toString()].sMeaning = e.target.value;
						setInputValue({...inputValue});
					}} />
				</div>
				<div className={s.growWrap} style={{maxWidth:"100px",width:"100px",minWidth:"100px"}} dataReplicatedValue={d.ipa}>
					<textarea rows="1" value={d.ipa} onChange={(e)=>{
						data[indexD].ipa = e.target.value;
						setData([...data])
						
						inputValue[d.wordId.toString()] = d;
						inputValue[d.wordId.toString()].ipa = e.target.value;
						setInputValue({...inputValue});
					}} />
				</div>
				<div className={s.wordMsgDate} >{modifiedDate(d.updateTs)} @ {d.username}</div>
			</div>))
		}
	
	</div>);
}

const PagePanel = ({totalCnt, page, choosePage, limit}) => {
	if (totalCnt == 0) {
		return (<div style={{padding:"0 15px",margin:"0 5px"}}><span>-</span></div>)
	}
	
	let totalPage = Math.ceil(totalCnt / limit);
	
	return (<div style={{padding:"0",margin:"0", display:"flex", flexWrap:"wrap"}}>
		{
			Array.from({ length: totalPage }, (_, index) => (
				<div className={s.clickableOption + ' ' + s.pagePanelBtn}
					style={(page == (index+1)) ? {background:"#ebccad"} : {}} key={index}
					onClick={() => {
						
						if (index+1 != page) {
							choosePage(index+1)
						}
					}}					
					>
					{index + 1}
				</div>
			))
		}
	</div>);
}

export default function WordAnalysis(props) {
	const navigate = useNavigate();
	const [logger] = useOutletContext();
	
	
	
	const [searchParams, setSearchParams] = useSearchParams();
	const [target, setTarget] = useState(getGeneralStorage('wordAnalysisTarget') ?? "dse-excellence");
	const [format, setFormat] = useState(getGeneralStorage('wordAnalysisFormat') ?? "qmeaning");
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(100);
	const [itemId, setItemId] = useState(null);
	
	//alphabet, id, update
	const [orderBy, setOrderBy] = useState('update');
		
	const [wordData, setWordData] = useState([]);
	
	const [inputValue, setInputValue] = useState({});
  const [timer, setTimer] = useState(null);

	const [totalCnt, setTotalCnt] = useState(0);

	const [targetAndLevelData, setTargetAndLevelData] = useState(targetAndLevelDefaultData);

  useEffect(() => {
    clearTimeout(timer);
    // Start a new timer after 10 seconds of inactivity
		
    if (Object.keys(inputValue).length > 0) {
      const newTimer = setTimeout(() => {
				updateData();
      }, 3000);

      setTimer(newTimer);
    }
  }, [inputValue]);
	
	
	const updateData = async () => {
		clearTimeout(timer);
		
		const newArray = Object.values(inputValue);
		for (let w of newArray) {
			if (w.qcType) {
				let obj = {
					wordId : w.wordId,
					id : w.qId,
					question: w.question,
					explanation: w.explanation,
					answer : w.answer,
					answerLpIds:[{id:w.wordId}],
					choice1 : w.option1,
					choice1LpIds:[],
					choice2 : w.option2,
					choice2LpIds:[],
					choice3 : w.option3,
					choice3LpIds:[],
					qcType: w.qcType,
				}
				
				await postData("questionApi/updateOrCreateQuestion", obj, navigate)
			} else if (w.meaning || w.sMeaningHk || w.ipa) {
				let obj = {
					wordId : w.wordId,
					sMeaning : w.sMeaning,
					sMeaningHk : w.sMeaningHk,
					ipa : w.ipa,
				}
				
				await postData("wordApi/updateWordV2", obj, navigate)
				await postData("wordApi/updateAudioIpa", obj, navigate)
			}
		}
		
		setInputValue({})
	}
	
	const fetchData = async (target, format, page, limit, orderBy, itemId) => {		
		if (Object.keys(inputValue).length > 0) {
			await updateData();
		}
		
		console.log(target, format, page, limit, orderBy, itemId)
		
		if ((target == 'item' || target == 'word') && !itemId) {
			return;
		}
		
		let myParam = {target, format, page, limit, itemId, orderBy};
		
		setWordData([]);
		
		getData('wordApi/analysis?' + (new URLSearchParams(myParam)).toString(), navigate)
		.then(res => {			

			if (res.data.length == 0 && page > 1) {
				setSearchParams({target, format, page:1, limit, itemId});
				fetchData(target, format, 1, limit, orderBy, itemId);
			} else {
				setWordData(res.data);
				
				let cnt = res.cnt;
				setTotalCnt(res.cnt);
				
				
				setTargetAndLevelData(targetAndLevelData.map(i => {
					if (i.searchKey == target) {
						return { ...i, count: cnt };
					}
					return i;
				}));
				
				
			}
		});
		setTarget(target);
		setFormat(format);
		setPage(page);
		setLimit(limit);
		setOrderBy(orderBy);
		
		setGeneralStorage('wordAnalysisTarget', target);
		setGeneralStorage('wordAnalysisFormat', format);
	}
	
	const searchByItem = () => {
		let target = searchParams.get("target") || null;
		let format = searchParams.get("format") || null;
		let page = searchParams.get("page") || 1;
		let limit = searchParams.get("limit") || 100;
		let orderBy = searchParams.get("orderBy") || "alphabet";
		
		let myParam = {target, format, page, limit, itemId, orderBy};
		setSearchParams(myParam);
		if (target == null || format == null || page == null || limit == null || orderBy == null) { return; }
		
		if ((target == 'item' || target == 'word') && itemId) {			
			fetchData(target, format, page, limit, orderBy, itemId);
		}
	}
	
	const chooseTargetAndLevel = (target) => {
		let format = searchParams.get("format") || null;
		let page = searchParams.get("page") || 1;
		let limit = searchParams.get("limit") || 100;
		let orderBy = searchParams.get("orderBy") || "alphabet";
		
		setItemId(null);
		
		let myParam = {target, format, page, limit, orderBy};
		setSearchParams(myParam);

		if (target == null || format == null || page == null || limit == null || orderBy == null) { return; }
		
		fetchData(target, format, page, limit, orderBy, itemId);
	}
	
	const chooseFormat = (format) => {
		let target = searchParams.get("target") || null;
		let itemId = searchParams.get("itemId") || null;
		let page = searchParams.get("page") || 1;
		let limit = searchParams.get("limit") || 100;
		let orderBy = searchParams.get("orderBy") || "alphabet";
		
		let myParam = {target, format, page, limit, itemId, orderBy};
		setSearchParams(myParam);
		
		setFormat(format);
		
		if (target == null || format == null || page == null || limit == null || orderBy == null) { return; }
		
		fetchData(target, format, page, limit, orderBy, itemId);
	}
	
	const choosePage = (page) => {	
		let target = searchParams.get("target") || null;
		let itemId = searchParams.get("itemId") || null;
		let format = searchParams.get("format") || null;
		let limit = searchParams.get("limit") || 100;
		let orderBy = searchParams.get("orderBy") || "alphabet";
		
		let myParam = {target, format, page, limit, itemId, orderBy};
		setSearchParams(myParam);
		if (target == null || format == null || page == null || limit == null || orderBy == null) { return; }
		
		fetchData(target, format, page, limit, orderBy, itemId);
	}
	
	const chooseOrderBy = (orderBy) => {	
		let target = searchParams.get("target") || null;
		let itemId = searchParams.get("itemId") || null;
		let format = searchParams.get("format") || null;
		let page = searchParams.get("page") || 1;
		let limit = searchParams.get("limit") || 100;
		
		let myParam = {target, format, page, limit, itemId, orderBy};
		setSearchParams(myParam);
		if (target == null || format == null || page == null || limit == null || orderBy == null) { return; }
		
		fetchData(target, format, page, limit, orderBy, itemId);
	}
	
	const chooseLimit = (limit) => {	
		let target = searchParams.get("target") || null;
		let itemId = searchParams.get("itemId") || null;
		let format = searchParams.get("format") || null;
		let page = searchParams.get("page") || 1;
		let orderBy = searchParams.get("orderBy") || "alphabet";
		
		let myParam = {target, format, page, limit, itemId, orderBy};
		setSearchParams(myParam);
		if (target == null || format == null || page == null || limit == null || orderBy == null) { return; }
		
		fetchData(target, format, page, limit, orderBy, itemId);
	}
	
	useEffect(() => {		
		let target = searchParams.get("target") || (getGeneralStorage('wordAnalysisTarget') ?? "dse-excellence");
		let format = searchParams.get("format") || (getGeneralStorage('wordAnalysisFormat') ?? "qmeaning");
		let page = searchParams.get("page") || 1;
		let limit = searchParams.get("limit") || 100;
		let orderBy = searchParams.get("orderBy") || "alphabet";
		let itemId = searchParams.get("itemId") || null;
		
		if ((itemId == null && target == null) || format == null || page == null || limit == null || orderBy == null) { return; }
		
		if (itemId != null) {
			setItemId(itemId);
		}
		
		setSearchParams({target, format, page, limit, itemId, orderBy});
		fetchData(target, format, page, limit, orderBy, itemId);
	}, []);

	const createWordQtn = async (wordId, word) => {
		console.log(wordId);
		let qcType = (format == 'qmeaning') ? 49 : 50;
				
		let obj = {
			wordId,
			qcType,
			question: 'What does the word "' + word + '" mean?',
			explanation: "",
			answer : "",
			answerLpIds:[{id:wordId}],
			choice1 : "",
			choice1LpIds:[],
			choice2 : "",
			choice2LpIds:[],
			choice3 : "",
			choice3LpIds:[],
		}
		
		let res = await postData("questionApi/updateOrCreateQuestion", obj, navigate)
		
		for (let w of wordData) {
			if (w.wordId == wordId) {
				w.qcType = qcType;
				w.question = 'What does the word "' + word + '" mean?';
				w.explanation = "";
				w.answer = "";
				w.option1 = "";
				w.option2 = "";
				w.option3 = "";
				w.qId = res.data;
				w.username = "ME";
				w.updateTs = Date.now();
				
				setWordData([...wordData])
				break;
			}
			
		}
		
		
	}

	return (<div style={{display:"flex", flexDirection:"column", color:"#4b3f1b"}}>
		{
			(Object.keys(inputValue).length > 0) && (<div className={s.pendingMsgHolder} >
				<img className={s.pendingMsg} src={uploadPng} />Uploading...
			</div>)
		}
		<div className={s.header}>Word Analysis</div>
		<div className={s.paramHolder}>
			{
				(target != 'item' && target != 'word' ) && (<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
					<div style={{display:"flex", padding:"10px 0 0 0"}}>
						<div className={s.nonClickableTitle}
							
						><span style={{cursor:"pointer"}} onClick={()=>{
								setTarget('item')
								chooseTargetAndLevel('item')
							}}	>Target & level</span></div>
						<div style={{fontWeight:"bold"}}>:</div>		
					</div>
					<div className={s.paramSectionHolder}>
						{
							targetAndLevelData.map(
								(d, indexD) => (<>
									<div key={'tAndL-'+indexD} className={s.clickableOption}
										style={(target == d.searchKey) ? {background:"#ebccad"} : {}}
										onClick={() => {
											if (d.searchKey != target) {
												chooseTargetAndLevel(d.searchKey)
											}
										}}
									>{d.title} 
										{(d.count != null) && (<span className={s.targetCnt}> {d.count}</span>)}
									</div>
									{(indexD != targetAndLevelData.length-1) &&(<span>•</span>)}
								</>)
							)
						}
					</div>
				</div>)
			}
			{
				(target == 'item') && (<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
					<div style={{display:"flex", padding:"10px 0 0 0"}}>
						<div className={s.nonClickableTitle}
							
						><span style={{cursor:"pointer"}} onClick={()=>{
							setTarget("word")
							chooseTargetAndLevel('word')
						}}>Item</span></div>
						<div style={{fontWeight:"bold"}}>:</div>		
					</div>
					<div className={s.itemHolder}>
						<input value={itemId} type="number" onChange={(e)=>{
							setItemId(e.target.value);
						}} />
						<div className={(itemId > 0) ? s.btnActive : s.btnInactive}
							onClick={searchByItem}
							>search</div>
					</div>
				</div>)
			}
			{
				(target == 'word') && (<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
					<div style={{display:"flex", padding:"10px 0 0 0"}}>
						<div className={s.nonClickableTitle}
							
						><span style={{cursor:"pointer"}} onClick={()=>{
							setTarget("dse-excellence")
							chooseTargetAndLevel('dse-excellence')
						}}>Word</span></div>
						<div style={{fontWeight:"bold"}}>:</div>		
					</div>
					<div className={s.itemHolder}>
						<input value={itemId} type="text" onChange={(e)=>{
							setItemId(e.target.value);
						}} />
						<div className={(itemId) ? s.btnActive : s.btnInactive}
							onClick={searchByItem}
							>search</div>
					</div>
				</div>)
			}
			
			
			<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>Analysis</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
			
				<div className={s.paramSectionHolder}>
					{
						formatData.map(
							(d, indexD) => (<>
								<div key={'format-'+indexD} className={s.clickableOption}
									style={(format == d.searchKey) ? {background:"#ebccad"} : {}}
									onClick={() => {
										if (d.searchKey != format) {
											chooseFormat(d.searchKey)
										}
									}}
									>{d.title}</div>
									{(indexD != formatData.length-1) &&(<span>•</span>)}
							</>)
						)
					}
			
				</div>
			</div>
			
			<div style={{display:"flex", borderBottom:"1px solid #4b3f1b"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>Order By</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
			
				<div className={s.paramSectionHolder}>
					<div className={s.clickableOption} style={(orderBy == "alphabet") ? {background:"#ebccad"} : {}}
						onClick={() => { if (orderBy != "alphabet") { chooseOrderBy("alphabet") } }}>alphabet</div>
					<span>•</span>
					<div className={s.clickableOption} style={(orderBy == "id") ? {background:"#ebccad"} : {}}
						onClick={() => { if (orderBy != "id") { chooseOrderBy("id") } }}>id</div>
					<span>•</span>
					<div className={s.clickableOption} style={(orderBy == "update") ? {background:"#ebccad"} : {}}
						onClick={() => { if (orderBy != "update") { chooseOrderBy("update") } }}>update</div>
					
				</div>
			</div>
			
			<div style={{display:"flex"}}>
				<div style={{display:"flex", padding:"10px 0 0 0"}}>
					<div className={s.nonClickableTitle}>Page
						<span className={s.limitSpan}
							onClick={
								()=> {
									if (limit == 10) {
										setLimit(50);
										chooseLimit(50);
									} else if (limit == 50) {
										setLimit(100);
										chooseLimit(100);
									} else {
										setLimit(10);
										chooseLimit(10);
									}
								}
							}
						>{limit}</span>
						</div>
					<div style={{fontWeight:"bold"}}>:</div>		
				</div>
				<div className={s.paramSectionHolder} >
					<PagePanel totalCnt={totalCnt} page={page} choosePage={choosePage} limit={limit}/>
				</div>
			</div>
			
		</div>
		<div>
		{
			(format == 'qmeaning' || format == 'qmeaninghk') && 
			(<FormatMeaningQtn format={format} data={wordData} setData={setWordData} inputValue={inputValue} setInputValue={setInputValue} createWordQtn={createWordQtn}/>)
		}
		{
			(format == 'wordbasic') &&
			(<FormatBasic data={wordData} setData={setWordData} inputValue={inputValue} setInputValue={setInputValue} />)
		}
		
		</div>
		
	</div>);
}



const targetAndLevelDefaultData = [
	{ title: 'DSE Excellence', searchKey: 'dse-excellence', availableFormat:[] },
	{ title: 'DSE Survival (Words in Questions)', searchKey: 'dse-survival-words-in-questions', availableFormat:[] },
	{ title: 'DSE Survival (Stance/tone/attitude)', searchKey: 'dse-survival-Stance-tone-attitude', availableFormat:[] },
	{ title: 'DSE Survival (Literary devices)', searchKey: 'dse-survival-literary-devices', availableFormat:[] },
	{ title: 'DSE Survival (General)', searchKey: 'dse-survival-general', availableFormat:[] },
	{ title: 'Pre-DSE Foundation (lv1)', searchKey: 'pre-dse-foundation-lv1', availableFormat:[] },
	{ title: 'Pre-DSE Foundation (lv2)', searchKey: 'pre-dse-foundation-lv2', availableFormat:[] },
	{ title: 'Pre-DSE Foundation (lv3)', searchKey: 'pre-dse-foundation-lv3', availableFormat:[] }
	
]

const formatData = [
	{ title: 'Basic Data', searchKey: 'wordbasic'},
	{ title: 'Qtn meaning', searchKey: 'qmeaning'},
	{ title: 'Qtn HK meaning', searchKey: 'qmeaninghk'},	
]